<template lang="pug">
	.contieneBloque(
		@drop="dropped($event, true)"
		droppable
		@dragover="dragOver($event, true)"
		@dragenter="dragEnter($event, true)"
		@dragleave="dragOut($event, true)"
		tabindex="5"
		@keydown="teclaAbajo"
		@keyup="teclaArriba"
	)
		img(id="imgdrag", ref="imgdrag", src="./footage/drag.png", style="display:none;")
		table.table.table-striped
			thead.bg-dark.text-white
				tr
					th.p-1 #
					th.p-1 H. inicio
					th.p-1 H. fin
					th.p-1 Nombre fichero
					th.p-1.text-right Duración
			tbody
				tr.fila(
					v-for="(ins, i) in listadoParrilla"
					:key="ins.ProgramacionID"
					@click="selecciona(ins)"
					:class="(seleccion.indexOf(ins) >= 0) ? 'bg-info' : ''"
					style="cursor: default;box-sizing: border-box;"
					:style="_getEstilo(ins.BuzonColor)"
					draggable
					@dragstart="dragStart($event, ins)"
					@dragover="dragOver($event, false, ins)"
					@dragenter="dragEnter($event, false, ins)"
					@dragleave="dragOut($event, false, ins)"
					@drop="dropped($event, ins)"
					@contextmenu="menuContextual($event, ins, 'parrilla')"
					:ref="'objeto-parrilla-' + ins.ProgramacionID"
				)
					td.p-1.bg-white.text-dark {{i + 1}}
					td.p-1.text-white(:style="(ins.HoraComienza > ins.HoraFinUnix) ? {backgroundColor: 'red'} : {backgroundColor: 'green'}") {{ins.HoraComienza | moment('HH:mm:ss')}}
					td.p-1.text-white(:style="(ins.HoraFinaliza > ins.HoraFinUnix) ? {backgroundColor: 'red'} : {backgroundColor: 'green'}") {{ins.HoraFinaliza | moment('HH:mm:ss')}}
					td.p-1
						span.text-danger.mr-2.p-1(v-if="ins.alertaLocs", style="font-weight:bold;background-color:black;")
							span.fa.fa-exclamation-triangle
						span.text-warning.mr-2.p-1(v-if="ins.alertaAnun", style="font-weight:bold;background-color:black;")
							soan.fa.fa-bell-slash
						span {{ins.ObjetoDescripcion}}
					td.p-1.text-right {{_getDuracionFisica(ins.DuracionFisica)}}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	props: ['filtro', 'insertar'],
	data () {
		return {
			indice: null,
			teclas: {
				ctrl: false,
				shift: false
			},
			nuevaPosicion: 1
		}
	},
	mounted () {
		if (!this.parrilla || !this.bloque) {
			this.getParrilla()
		}
	},
	watch: {
		insertar: function (newVal) {
			if (Array.isArray(newVal) && newVal.length > 0) {
				this.agregarObjetos(newVal, null, false)
				this.$emit('update:insertar', [])
			}
		}
	},
	computed: {
		...mapGetters({
			bloque: 'organizar-emisoras/bloqueActivo',
			parrilla: 'organizar-emisoras/insercionesParrilla',
			seleccion: 'organizar-emisoras/seleccionInserciones'
		}),
		listadoParrilla () {
			if (!this.parrilla) {
				return []
			}
			const anunciantesMap = new Map()
			return this.parrilla.map((v, i) => {
				v.alertaLocs = false
				v.alertaAnun = false

				if (v.anunciante && anunciantesMap.has(v.anunciante.AnuncianteID)) {
					v.alertaAnun = true
				} else if (v.anunciante) {
					anunciantesMap.set(v.anunciante.AnuncianteID, i)
				}

				if (v.locutores && v.locutores.length === 0) {
					return v
				}
				let anterior = null
				let siguiente = null
				if (i > 0) {
					anterior = this.parrilla[i - 1]
				}
				if (i < this.parrilla.length - 1) {
					siguiente = this.parrilla[i + 1]
				}

				if (anterior && anterior.locutores && anterior.locutores.length > 0) {
					for (let i = 0; i < anterior.locutores.length; i++) {
						const antL = anterior.locutores[i]
						for (let l = 0; l < v.locutores.length; l++) {
							const actL = v.locutores[l]
							if (actL.ID_locutor === antL.ID_locutor) {
								v.alertaLocs = true
							}
						}
					}
				}

				if (siguiente && siguiente.locutores && siguiente.locutores.length > 0) {
					for (let i = 0; i < siguiente.locutores.length; i++) {
						const antL = siguiente.locutores[i]
						for (let l = 0; l < v.locutores.length; l++) {
							const actL = v.locutores[l]
							if (actL.ID_locutor === antL.ID_locutor) {
								v.alertaLocs = true
							}
						}
					}
				}

				return v
			})
		}
	},
	methods: {
		...mapActions({
			getParrilla: 'organizar-emisoras/getParrilla',
			programar: 'organizar-emisoras/programarInserciones',
			desprogramar: 'organizar-emisoras/desprogramarInserciones'
		}),
		selecciona (ins) {
			const datos = {
				insercion: ins,
				ctrl: this.teclas.ctrl,
				shift: this.teclas.shift
			}
			this.$store.commit('organizar-emisoras/SELECCIONA_INSERCION', datos)
		},
		teclaAbajo (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey

			if (e.keyCode === 46) {
				// Eliminamos
				this.quitarObjetos()
			}

			if (e.keyCode === 32 && this.seleccion.length > 0) {
				this.$emit('reproducir', this.seleccion[0].ObjetoID)
			}

			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(1)
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(-1)
			}
		},
		teclaArriba (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
		},
		seleccionaIndice (inc) {
			const idx = this.parrilla.indexOf(this.seleccion[this.seleccion.length - 1])
			const indice = (idx + inc >= this.parrilla.length) ? 0 : (idx + inc < 0) ? this.parrilla.length - 1 : idx + inc
			this.selecciona(this.parrilla[indice])
			this.$refs['objeto-parrilla-' + this.seleccion[0].ProgramacionID][0].scrollIntoView({ block: 'end', behavior: 'instant' })
		},
		dragStart (e, objeto) {
			if (this.seleccion.indexOf(objeto) < 0) {
				this.selecciona(objeto)
			}
			e.dataTransfer.setData('text/json', JSON.stringify(this.seleccion))
			e.dataTransfer.setData('text/from', 'parrilla')
			e.dataTransfer.setData('text/eliminar', this.teclas.ctrl)
			e.dataTransfer.setDragImage(this.$refs.imgdrag, 0, 0)
		},
		dragOver (e, final, objeto) {
			e.preventDefault()
			e.stopPropagation()
			if (final) return
			const el = this._getElement(e.target)
			const per = this._getPercent(e)
			const idx = this.parrilla.indexOf(objeto)

			if (el) {
				if (per < 50) {
					el.className = 'fila up'
					if (this.seleccion.indexOf(objeto) >= 0) {
						el.className += ' bg-info'
					}
					if (idx >= 0) {
						this.nuevaPosicion = this.parrilla[idx].ProgramacionOrden
					}
				} else {
					el.className = 'fila down'
					if (this.seleccion.indexOf(objeto) >= 0) {
						el.className += ' bg-info'
					}
					if (idx) {
						this.nuevaPosicion = this.parrilla[idx].ProgramacionOrden + 1
					}
				}
			}
		},
		dragEnter (e, final, objeto) {
			e.preventDefault()
			e.stopPropagation()
		},
		dragOut (e, final, objeto) {
			e.preventDefault()
			e.stopPropagation()
			if (final) return
			const el = this._getElement(e.target)
			if (el) {
				el.className = 'fila'
			}
			if (this.seleccion.indexOf(objeto) >= 0) {
				el.className += ' bg-info'
			}
		},
		dropped (e, objeto) {
			e.preventDefault()
			e.stopPropagation()
			const objetos = JSON.parse(e.dataTransfer.getData('text/json')).map(
				o => o.ObjetoID
			)
			const from = e.dataTransfer.getData('text/from')
			const ctrl = e.dataTransfer.getData('text/eliminar')
			const el = this._getElement(e.target)
			let posicion = 1
			if (el) {
				const per = this._getPercent(e)
				posicion = (per < 50) ? objeto.ProgramacionOrden : objeto.ProgramacionOrden + 1
				el.className = 'fila'
				// this.agregarObjetos(objetos, posicion, eliminar)
			} else {
				if (e.target.tagName === 'TH') {
					posicion = 1
				} else {
					// Última posicion
					posicion =
						this.parrilla.length > 0
							? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1
							: 1
				}
				// this.agregarObjetos(objetos, pos, eliminar)
			}
			let fnEliminar = null
			if (ctrl === 'false' && from === 'parrilla') {
				fnEliminar = () => this.desprogramar(this.seleccion)
			}
			if (ctrl === 'true' && from === 'favoritos') {
				const favs = JSON.parse(e.dataTransfer.getData('text/json')).map(f => f.ID_favorito)
				fnEliminar = () => {
					this.$store.dispatch('organizar-emisoras/delFicherosFavoritos', favs)
					this.$store.dispatch('organizar-emisoras/getParrilla')
				}
			}
			const datos = {
				ficheros: objetos,
				posicion: (isNaN(posicion)) ? 1 : posicion,
				callback: fnEliminar
			}
			this.programar(datos)
		},
		menuContextual (e, objeto) {
			e.preventDefault()
			e.stopPropagation()
			if (this.seleccion.indexOf(objeto) < 0) {
				this.selecciona({ProgramacionID: objeto.ProgramacionID, agregado: this.teclas.ctrl})
			}
			const menu = {
				titulo: 'Fichero',
				items: [],
				evento: e
			}

			menu.items.push({
				texto: 'Reproducir',
				icono: 'fa fa-play',
				activo: true,
				callback: () => {
					this.$emit('reproducir', objeto.ObjetoID)
				}
			})

			menu.items.push({
				texto: 'Quitar',
				icono: 'fa fa-trash',
				activo: true,
				callback: () => {
					this.quitarObjetos()
				}
			})

			this.$store.commit('contextual/mostrar', menu)
		},
		agregarObjetos (ObjetosID, posicion, eliminar) {
			// Verificamos si ObjetoID es un int
			if (!Array.isArray(ObjetosID)) {
				return
			}

			if (!this.bloque) {
				return
			}

			eliminar = typeof eliminar === 'boolean' ? eliminar : false
			if (this.parrilla.length > 0) {
				posicion =
					typeof posicion !== 'number' || posicion <= 0
						? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1
						: posicion
			} else {
				posicion = 1
			}

			const programa = () => {
				if (ObjetosID.length === 0) {
					// TODO: Emitir evento para actualizar los bloques
					if (eliminar && this.parrilla.length > 0) {
						this.quitarObjetos(true)
					} else {
						this.$emit('actualizar')
						this.getParrilla()
					}
					return
				}

				const oID = ObjetosID.splice(0, 1)[0]
				this.programaObjeto(oID, posicion)
					.then(res => {
						posicion++
						programa()
					})
					.catch(this.$responseError)
			}
			programa()
		},

		programaObjeto (ObjetoID, ProgramacionOrden) {
			const datos = {
				ObjetoID: ObjetoID,
				dia: Math.round(this.filtro.dia.getTime() / 1000),
				BloqueID: this.bloque.BloqueID,
				ProgramacionOrden: ProgramacionOrden <= 0 ? 1 : ProgramacionOrden
			}
			return this.$http.post(
				'organizar-emisoras/php/api/programar-objeto.php',
				datos
			)
		},
		quitarObjetos (directo) {
			const datos = {
				ProgramacionesID: this.seleccion.map(p => p.ProgramacionID)
			}
			if (!directo) {
				this.$store.commit('alertas/confirm', {
					titulo: 'Quitar programación',
					mensaje: `¿Quieres quitar estos elementos del bloque?`,
					callback: acepta => {
						if (acepta) {
							this.desprogramar(this.seleccion)
						}
					}
				})
			} else {
				this.$store.dispatch('organizar-emisoras/desprogramar', datos)
			}
		},

		// PRIVADO
		_getDuracionFisica (dur) {
			let valor = dur / 10000000
			let neg = valor < 0
			valor = valor < 0 ? valor * -1 : valor
			let h = '00'
			let m = '00'
			let s = '00'
			let decimas = '000'
			decimas = valor.toString().match(/\./)
				? valor.toString().split('.')[1]
				: '000'

			if (valor >= 3600) {
				h = Math.floor(valor / 3600)
				h = h < 10 ? '0' + h : h
				valor = valor % 3600
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60)
				m = m < 10 ? '0' + m : m
				valor = valor % 60
			}

			s = parseInt(valor)
			s = s < 10 ? '0' + s : s

			decimas = decimas.toString()
			while (decimas.length < 3) {
				decimas = decimas + '0'
			}

			const menos = neg ? '-' : ''
			return menos + '' + h + ':' + m + ':' + s + '.' + decimas
		},

		_getEstilo (Color) {
			let hex = Color.toString(16)
			const reverse = str => {
				return str === '' ? '' : reverse(str.substr(1)) + str.charAt(0)
			}
			hex = reverse(hex)

			// Calculamos si la cadena es de 6
			while (hex.length < 6) {
				hex = hex + '0'
			}

			hex = hex === '000000' ? 'ffffff' : hex
			const getContrastYIQ = (r, g, b, opacidad) => {
				opacidad = 1 + opacidad
				const yiq =
					(r * 299 * opacidad + g * 587 * opacidad + b * 114 * opacidad) / 1000
				return yiq >= 128 ? 'black' : 'white'
			}

			hex = hex.replace('#', '')
			const r = parseInt(hex.substring(0, 2), 16)
			const g = parseInt(hex.substring(2, 4), 16)
			const b = parseInt(hex.substring(4, 6), 16)
			const opacidad = 0.6

			hex = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + opacidad + ')'

			return {
				backgroundColor: hex,
				color: getContrastYIQ(r, g, b, opacidad)
			}
		},
		_getElement (el) {
			if (el.className.match(/contieneBloque/)) {
				// Estamos dropando en el contenedor, situaremos la inserción al final
				return null
			}
			while (el && !el.className.match(/fila/)) {
				el = el.parentElement
			}

			return (el && el.className.match(/fila/)) ? el : null
		},
		_getPercent (e) {
			const el = this._getElement(e.target)
			const alto = el.offsetHeight
			const top = e.offsetY
			return Math.round(top * 100 / alto)
		}
	}
}
</script>
<style scoped>
	.fila.up > td {
		border-top: 1px solid black;
	}

	.fila.down > td {
		border-bottom: 1px solid black;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/parrilla.vue